<template>
  <div id="app-header">
    <center-spinner :loading="loading" />
    <div class="header">
      <img
        src="@/assets/img/logo-icon.png"
        alt=""
      >
      <v-spacer />
      <v-select
        v-if="checkOnlyOneOrgExist"
        v-model="currentSelectedOrganization"
        light
        color="#37474F"
        flat
        dense
        :items="appUserOrganizations"
        item-text="organization.name"
        item-value="organization.external_id"
        value="organization.external_id"
        label="Organization"
        outlined
        background-color="transparent"
        class="small-select"
        return-object
        :menu-props="{ bottom: true, offsetY: true }"
        @change="changeOrganization"
      />
      <v-spacer />
      <v-btn
        v-if="selectedOrganization.active"
        fab
        small
        color="#ccc"
        elevation="0"
        outlined
        @click="checkinCheckout()"
      >
        <v-icon color="#000">
          mdi-qrcode
        </v-icon>
      </v-btn>
    </div>
    <alert-dialog
      v-if="showLogoutAlert"
      :title="'Confirm Log out'"
      :message="'Are you sure you want to log out of the app ?'"
      @closed="showLogoutAlert = false"
      @confirmed="logoutConfirmed()"
    />
    <check-in-types
      v-if="showCheckInTypes"
      @closed="showCheckInTypes = false"
      @checkin-type-selected="continueCheckInProcess"
    />
    <select-organization
      v-if="showOrganizationsList"
      @closed="showOrganizationsList = false"
      @organization-selected="toCheckInTypes"
    />
    <check-in-sheet-qr
      v-if="openQrCheckinSheet"
      :gate="gateId"
      :qr-type="qrType"
      :location-enable-check="locationEnableCheck"
      @closed="openQrCheckinSheet = false"
    />
    <select-project-gate
      v-if="showProjectGates"
      @closed="showProjectGates = false"
      @project-gate-selected="toSelectedCheckInProcessByManual"
    />
    <qr-code-scanner
      v-if="showQrCodeScanner"
      @closed="showQrCodeScanner = false"
      @qr-code-scanned="toSelectedCheckInProcessByQRScan"
    />
    <qr-code-scanner
      v-if="showCheckoutQrCodeScanner"
      @closed="showCheckoutQrCodeScanner = false"
      @qr-code-scanned="toSelectedCheckOutProcessByQRScan"
    />
    <check-out-sheet-qr
      v-if="openCheckOutQrSheet"
      :gate="gateId"
      :location-enable-check="locationEnableCheck"
      @closed="openCheckOutQrSheet = false"
    />
    <alert-dialog
      v-if="showAlert"
      :title="'⚠️ Check-out Too Early ?'"
      :message="'You have logged less than 15 minutes. If you proceed, the timesheet will be deleted as its considered invalid. Do you want to continue with check-out?'"
      @closed="showAlert = false"
      @confirmed="toCheckOutProcess()"
    />
  </div>
</template>

<script>
import spinner from 'src/views/components/SpinnerCentre';
import AlertDialog from 'src/views/components/AlertDialog.vue';
import Constants from 'src/constants';
import CheckInSheetQr from '../dashboard/Components/CheckInSheetQr.vue';
import SelectOrganization from 'src/views/dashboard/Components/dialogComponents/SelectOrganization';
import SelectProjectGate from 'src/views/dashboard/Components/dialogComponents/SelectProjectGate';
import CheckInTypes from 'src/views/dashboard/Components/CheckInTypes';
import QrCodeScanner from '../process/QrCodeScanner.vue';
import CheckOutSheetQr from '../dashboard/Components/CheckOutSheetQr.vue';
export default {
  name: 'AppHeader',
  components: {
    'center-spinner': spinner,
    'alert-dialog': AlertDialog,
    'check-in-sheet-qr': CheckInSheetQr,
    'select-organization': SelectOrganization,
    'select-project-gate': SelectProjectGate,
    'check-in-types': CheckInTypes,
    'qr-code-scanner': QrCodeScanner,
    'check-out-sheet-qr': CheckOutSheetQr,
  },
  data: () => ({
    loading: false,
    showLogoutAlert: false,
    currentSelectedOrganization: null,
    openQrCheckinSheet: false,
    showOrganizationsList: false,
    checkInMethodType: '',
    showProjectGates: false,
    showCheckInTypes: false,
    showQrCodeScanner: false,
    openCheckOutQrSheet: false,
    showCheckoutQrCodeScanner: false,
    showAlert: false,
  }),
  computed: {
    appUserOrganizations () {
      return this.$store.getters['organization/getUserOrganizations'];
    },
    checkOnlyOneOrgExist () {
      return this.appUserOrganizations.length > 1;
    },
    userOrganizations () {
      return this.$store.getters['organization/getUserOrganizations'];
    },
    userData () {
      return this.$store.getters.getSelectedOrganization;
    },
    firstOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
    locationEnableCheck () {
      return this.orgSettings.location_verification;
    },
    orgSettings () {
      return this.$store.getters['organization/getOrganizationSettings'];
    },
    activeCheckInDetails () {
      return this.$store.getters['swiftuser/getActiveCheckInDetails'];
    },
    isActiveCheckInDetailsFetched () {
      if (Object.keys(this.activeCheckInDetails).length > 0) {
        return true;
      }
      return false;
    },
  },
  mounted () {
    this.loadOnMount();
  },
  methods: {
    async loadOnMount () {
      this.loading = true;
      await this.getUserOrganizations();
      await this.checkIfOrgExist();

      this.loading = false;
    },
    checkQrScanTime () {
      const scannedTime = localStorage.getItem('scannedTime');
      if (scannedTime === null) {
        return;
      }
      const currentTime = new Date().getTime();
      if (currentTime - scannedTime >= 300000) {
        localStorage.removeItem('siteId');
        localStorage.removeItem('scannedTime');
      }
    },
    checkinCheckout () {
      if (Object.keys(this.activeCheckInDetails).length !== 0) {
        const checkInTime = localStorage.getItem('checkInTime');
        if (checkInTime) {
          const checkInMs = parseInt(checkInTime, 10);
          const now = Date.now();
          const diffMinutes = (now - checkInMs) / (1000 * 60);

          if (this.userData.timesheet_tracking && diffMinutes < 15) {
            this.showAlert = true;
            return;
          }
        }
        this.showCheckoutQrCodeScanner = true;
        // this.toCheckOutProcess();
      } else {
        this.toCheckInProcess('qr-code');
      }
    },
    toSelectedCheckOutProcessByQRScan (id) {
      this.showCheckoutQrCodeScanner = false;
      this.$store.dispatch('swiftuser/storeCheckOutMethodType', {
        type: 'qrScan',
      });
      this.gateId = id;
      this.openCheckOutQrSheet = true;
      // const type = this.activeCheckInDetails.type;
      // const siteId = id;
      // this.$router.push(`check-out/${siteId}/${type}`);
    },
    toCheckOutProcess (type) {
      this.showCheckoutQrCodeScanner = true;
    },
    async getUserOrganizations () {
      this.loading = true;
      await this.$store.dispatch('organization/fetchUserOrganizations', {
        params: {
          requestStatus: 'accepted',
        },
      });
      this.loading = false;
    },
    toSelectedCheckInProcessByManual () {
      this.loading = true;
      this.showOrganizationsList = false;
      this.showCheckInTypes = false;
      this.showOrganizationProjects = false;
      this.showProjectGates = false;
      const type = this.selectedCheckInType;
      const siteId = this.selectedOrgProjectGate.id;
      this.$router.push(`check-in/${siteId}/${type}`);
    },
    continueCheckInProcess (type) {
      this.showOrganizationsList = false;
      this.showCheckInTypes = false;
      this.selectedCheckInType = type;
      this.$store.dispatch('swiftuser/storeCheckInMethodType', {
        type: 'qr-code-checkin',
      });
      this.loading = false;
      this.openQrCodeScanner();
    },
    toSelectedCheckInProcessByQRScan (id) {
      if (id.length === 0 || id === 'undefined') {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'Unauthorized QR-Code',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        localStorage.removeItem('siteId');
        return;
      }
      this.showOrganizationsList = false;
      this.showCheckInTypes = false;
      this.showQrCodeScanner = false;
      this.gateId = id;
      this.qrType = this.selectedCheckInType;
      this.openQrCheckinSheet = true;
    },
    openQrCodeScanner () {
      this.loading = true;
      this.checkQrScanTime();
      const siteId = localStorage.getItem('siteId');
      if (siteId !== null) {
        this.toSelectedCheckInProcessByQRScan(siteId);
        this.loading = false;
        return;
      }
      this.showQrCodeScanner = true;
      this.loading = false;
    },
    toCheckInTypes () {
      if (this.selectedOrganization.types.length === 1) {
        this.showOrganizationsList = false;
        this.continueCheckInProcess(this.selectedOrganization.types[0]);
      } else {
        this.showOrganizationsList = false;
        this.showCheckInTypes = true;
      }
    },
    toCheckInProcess (type) {
      this.loading = true;
      this.checkInMethodType = type;
      if (this.userOrganizations.length > 0) {
        this.loading = true;
        this.$store.dispatch(
          'organization/selectedOrganization',
          this.selectedOrganization,
        );
        this.loading = false;
        this.toCheckInTypes();
      } else {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'You are not under any organizations.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        this.loading = false;
        this.$router.push({ name: 'Organizations' });
      }
    },
    checkIfOrgExist () {
      if (this.appUserOrganizations.length !== 0) {
        if (this.selectedOrganization !== null) {
          this.currentSelectedOrganization = this.selectedOrganization;
        } else {
          this.currentSelectedOrganization = this.appUserOrganizations[0];
          this.$store.commit(
            'setSeletedOrganization',
            this.currentSelectedOrganization,
          );
          location.reload();
        }
      }
    },
    async changeOrganization (data) {
      const route = this.$route.params.jobId;
      if (
        this.$route.path.includes(`${route}/details`) ||
        this.$route.path.includes(`${route}/comments`)
      ) {
        await this.$store.commit('setSeletedOrganization', data);
        await this.$store.dispatch('organization/setSelectOrganization', {
          selected_organization: data.app_user_organization_id,
        });
        this.$router.push({ path: '/jobs' });
        return;
      }
      await this.$store.commit('setSeletedOrganization', data);
      await this.$store.dispatch('organization/setSelectOrganization', {
        selected_organization: data.app_user_organization_id,
      });
      location.reload();
    },
  },
};
</script>

<style scoped>
#app-header {
  position: fixed;
  width: 100%;
  padding: 10px 15px;
  z-index: 9;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  background-color: rgba(255, 255, 255, 0.2);
}
.header {
  display: flex;
  align-items: center;
}
.logout-button {
  color: #37474f;
}
img {
  width: 40px;
}
.v-text-field >>> .v-text-field__details {
  margin-bottom: -13px !important;
}
.v-input {
  max-width: 60%;
  margin-top: 5px;
}
.v-input >>> .v-input__slot {
  background: #ffffffab !important;
}
.theme--dark.v-list {
  background-color: white !important;
}

.theme--dark >>> .v-list-item {
  color: #37474f !important;
}
</style>
